module.exports = __webpack_public_path__ + "media/images/icons/outlined/experiment-552a61b9e226c74728f30893490ea74e.svg";